import { render, staticRenderFns } from "./timedown.vue?vue&type=template&id=93053ba0&scoped=true&"
import script from "./timedown.vue?vue&type=script&lang=js&"
export * from "./timedown.vue?vue&type=script&lang=js&"
import style0 from "./timedown.vue?vue&type=style&index=0&id=93053ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93053ba0",
  null
  
)

export default component.exports